"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.number.constructor");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'BaseInfo',
  props: {
    custId: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      baseForm: {
        name: '',
        mobile: '',
        address: '',
        custWechat: '',
        isDistributor: '',
        inviter: '',
        msgFrom: '',
        zxFrom: ''
      },
      rules: {
        name: [],
        mobile: [],
        address: [],
        custWechat: [],
        isDistributor: [],
        msgFrom: [],
        zxFrom: []
      }
    };
  },
  mounted: function mounted() {
    // 组件挂载时查询接口获取客户信息
    this.init();
  },
  watch: {
    // 监听custId变化，重新加载数据
    custId: {
      handler: function handler(newVal) {
        if (newVal) {
          this.init();
        }
      },
      immediate: true
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      if (this.custId) {
        (0, _cmsWorkOrder.getCustInfo)(this.custId).then(function (response) {
          if (response && response.code === 200 && response.data) {
            var custInfo = response.data;
            _this.baseForm = {
              name: custInfo.name || '',
              mobile: custInfo.mobile || '',
              address: custInfo.address || '',
              custWechat: custInfo.custWechat || '',
              isDistributor: custInfo.isDistributor || '',
              inviter: custInfo.inviter || '',
              msgFrom: custInfo.msgFrom || '',
              zxFrom: custInfo.zxFrom || ''
            };
          }
        }).catch(function (error) {
          console.error('获取客户信息失败:', error);
        });
      }
    }
  }
};
exports.default = _default;